import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  nl: {
    hubKicker: "Jeugd- en sportvereniging · Diegem",
    hubTitle1: "Welke Inkad",
    hubTitle2: "zoek je?",
    hubLead: "Een toffe en leerrijke jeugd voor iedereen.",
    fcTag: "Sportvereniging",
    fcDesc: "Futsal, voetbal, wedstrijden en standen. Hier gebeurt elke dag iets.",
    jeugdTag: "Jeugdvereniging",
    jeugdDesc: "Activiteiten, huiswerkklas, kampen en liefdadigheid voor onze jeugd.",
    enter: "Ontdek",
    otherBranch: "Andere werking van Inkad",
    backToInkad: "Inkad",
    discoverInkad: "Ontdek Inkad",
    // nav
    nav_futsal: "Futsal", nav_minis: "Mini's", nav_veteranen: "Veteranen",
    nav_wedstrijden: "Wedstrijden", nav_inschrijven: "Inschrijven",
    nav_veldvoetbal: "Veldvoetbal",
    chooseSport: "Kies je sport",
    lastResult: "Laatste resultaat", allMatches: "Alle wedstrijden", allTeams: "Alle ploegen",
    lastUpdated: "Laatst bijgewerkt", competition: "Competitie",
    officialData: "Officiële data · Voetbal Vlaanderen",
    tGF: "DV", tGA: "DT", tGD: "DS",
    stPlanned: "Gepland", stLive: "LIVE", stFinished: "Einde", stPostponed: "Uitgesteld",
    stCancelled: "Afgelast", stForfeit: "Forfait",
    nav_clubshop: "Clubshop",
    nav_ploegen: "Ploegen",
    ploegenTitle: "Onze ploegen",
    ploegenKicker: "FC Inkad · Alle teams",
    ploegenLead: "Maak kennis met onze ploegen en coaches — van de allerkleinsten tot de veteranen.",
    coachLabel: "Coach", coachSoon: "Coach volgt binnenkort",
    teamPhotoSoon: "Ploegfoto volgt binnenkort",
    catJeugd: "Jeugd", catSenioren: "Senioren", catFutsal: "Futsal", catVeteranen: "Veteranen",
    stafKicker: "Onze mensen", stafTitle: "Staf & Coördinatie", roleJeugdcoordinator: "Jeugdcoördinator", roleVoorzitter: "Voorzitter",
    shopSoonBadge: "Binnenkort beschikbaar",
    shopSoonText: "Onze officiële clubshop opent binnenkort. Bestel er straks clubkledij en accessoires via onze leverancier — exclusief voor leden en supporters van FC Inkad.",
    shopFollow: "Volg de lancering op onze socials",
    sponsors: "Onze sponsors",
    resultsTab: "Resultaten", all: "Alle", noMatches: "Geen wedstrijden gevonden.",
    followTiktok: "Volg @inkad.diegem op TikTok",
    nav_activiteiten: "Zondagactiviteiten", nav_huiswerkklas: "Huiswerkklas",
    fotosLabel: "Foto's",
    nav_vakantiekampen: "Vakantiekampen", nav_liefdadigheid: "Liefdadigheid",
    nav_galerij: "Galerij",
    galerijTitle: "Onze Galerij", galerijLead: "Een blik op alles wat we samen beleven — van activiteiten tot kampen en feesten.",
    galerijEmpty: "Binnenkort verschijnen hier onze foto's.",
    // fc home
    fcHeroKicker: "FC Inkad · Diegem",
    fcHero1: "Elke dag", fcHero2: "in beweging", fcHero3: "op het veld",
    fcHeroLead: "Futsal, mini's en veteranen. Wedstrijden, standen en clubnieuws — live bijgewerkt.",
    liveUpdated: "Live bijgewerkt",
    nextMatch: "Volgende wedstrijd", upcoming: "Komende wedstrijden",
    recentResults: "Laatste uitslagen", standings: "Klassement",
    trainings: "Trainingen van de week", clubNews: "Clubnieuws",
    social: "Social media", teams: "Teams", contact: "Contact",
    today: "Vandaag", tomorrow: "Morgen", position: "Positie",
    viewAll: "Bekijk alles", joinClub: "Word lid van FC Inkad",
    // standings cols
    tPos: "#", tTeam: "Ploeg", tPl: "GS", tW: "W", tD: "G", tL: "V", tPts: "Ptn",
    // jeugd home
    jHeroKicker: "Inkad Jeugd · Diegem",
    jHero1: "Samen", jHero2: "groeien", jHero3: "en spelen",
    jHeroLead: "Een warme plek voor kinderen en jongeren. Activiteiten, huiswerkklas, kampen en solidariteit.",
    nextActivity: "Eerstvolgende activiteit",
    sundayActivities: "Zondagactiviteiten", homeworkClass: "Huiswerkklas",
    holidayCamps: "Vakantiekampen", recentActivities: "Recente activiteiten",
    charity: "Liefdadigheid", newsStories: "Nieuws & verhalen",
    joinJeugd: "Schrijf je kind in", whatWeDo: "Wat doen we?",
    whenNext: "Wanneer is de volgende activiteit?", howJoin: "Hoe kan mijn kind deelnemen?",
    // register
    regFcTitle: "Inschrijven bij FC Inkad",
    regFcLead: "Vul het formulier in en ons bestuur neemt contact op.",
    regJeugdTitle: "Inschrijven bij Inkad Jeugd",
    regJeugdLead: "Schrijf je kind in voor onze werking. We bezorgen je alle info.",
    fName: "Naam", fParent: "Naam ouder/voogd", fEmail: "E-mail",
    fPhone: "Telefoon", fBirth: "Geboortejaar", fProgram: "Werking / team",
    fMessage: "Bericht", submit: "Verstuur inschrijving", sending: "Versturen...",
    fFirstName: "Voornaam", fLastName: "Achternaam", fBirthDate: "Geboortedatum",
    fGender: "Geslacht", fBoy: "Jongen", fGirl: "Meisje", fAddress: "Adres",
    fRegisterFor: "Waarvoor wilt u zich inschrijven?",
    progHuiswerk: "Huiswerkbegeleiding", progZondag: "Zondagactiviteit (wekelijks)",
    volzetTag: "volzet",
    feeNotice: "Lidgeld: €{amt} — meteen online te betalen via Mollie na het versturen.",
    submitPay: "Inschrijven & €{amt} betalen",
    multipleAllowed: "meerdere keuzes mogelijk",
    feeOnRequest: "in overleg",
    huiswerkNote: "Huiswerkbegeleiding: het bedrag wordt na een eerste gesprek afgesproken.",
    payConfirming: "Betaling bevestigen…", payPaid: "Betaling geslaagd! Je inschrijving is bevestigd.",
    payOpen: "Betaling nog niet afgerond. We blijven de status controleren.",
    payFailed: "Betaling niet gelukt of geannuleerd.", payRetry: "Opnieuw proberen",
    backToClub: "Terug naar FC Inkad", backToYouth: "Terug naar Inkad Jeugd",
    regOk: "Bedankt! Je inschrijving is ontvangen.",
    regErr: "Er ging iets mis. Probeer opnieuw.",
    // contact
    cName: "Naam", cEmail: "E-mail", cMessage: "Bericht", cSend: "Verstuur",
    contactLead: "Vragen? Neem gerust contact met ons op.",
    contactOk: "Bericht verzonden. Bedankt!",
    footerRights: "Alle rechten voorbehouden.",
  },
  en: {
    hubKicker: "Youth & sports club · Diegem",
    hubTitle1: "Which Inkad", hubTitle2: "are you looking for?",
    hubLead: "A fun and enriching youth for everyone.",
    fcTag: "Sports club", fcDesc: "Futsal, football, matches and standings. Something happens every day.",
    jeugdTag: "Youth club", jeugdDesc: "Activities, homework class, camps and charity for our youth.",
    enter: "Discover", otherBranch: "Other Inkad branch", backToInkad: "Inkad", discoverInkad: "Discover Inkad",
    nav_futsal: "Futsal", nav_minis: "Minis", nav_veteranen: "Veterans",
    nav_wedstrijden: "Matches", nav_inschrijven: "Register",
    nav_veldvoetbal: "Football",
    chooseSport: "Choose your sport",
    lastResult: "Last result", allMatches: "All matches", allTeams: "All teams",
    lastUpdated: "Last updated", competition: "Competition",
    officialData: "Official data · Voetbal Vlaanderen",
    tGF: "GF", tGA: "GA", tGD: "GD",
    stPlanned: "Scheduled", stLive: "LIVE", stFinished: "Full time", stPostponed: "Postponed",
    stCancelled: "Cancelled", stForfeit: "Forfeit",
    nav_clubshop: "Club shop",
    nav_ploegen: "Teams",
    ploegenTitle: "Our teams",
    ploegenKicker: "FC Inkad · All teams",
    ploegenLead: "Meet our teams and coaches — from the youngest players to the veterans.",
    coachLabel: "Coach", coachSoon: "Coach coming soon",
    teamPhotoSoon: "Team photo coming soon",
    catJeugd: "Youth", catSenioren: "Seniors", catFutsal: "Futsal", catVeteranen: "Veterans",
    stafKicker: "Our people", stafTitle: "Staff & Coordination", roleJeugdcoordinator: "Youth Coordinator", roleVoorzitter: "Chairman",
    shopSoonBadge: "Coming soon",
    shopSoonText: "Our official club shop opens soon. Order club wear and accessories through our supplier — exclusively for FC Inkad members and supporters.",
    shopFollow: "Follow the launch on our socials",
    sponsors: "Our sponsors",
    resultsTab: "Results", all: "All", noMatches: "No matches found.",
    followTiktok: "Follow @inkad.diegem on TikTok",
    nav_activiteiten: "Sunday Activities", nav_huiswerkklas: "Homework Class",
    fotosLabel: "Photos",
    nav_vakantiekampen: "Holiday Camps", nav_liefdadigheid: "Charity",
    nav_galerij: "Gallery",
    galerijTitle: "Our Gallery", galerijLead: "A glimpse of everything we experience together — from activities to camps and parties.",
    galerijEmpty: "Our photos will appear here soon.",
    fcHeroKicker: "FC Inkad · Diegem",
    fcHero1: "Every day", fcHero2: "in motion", fcHero3: "on the pitch",
    fcHeroLead: "Futsal, minis and veterans. Matches, standings and club news — live updated.",
    liveUpdated: "Live updated", nextMatch: "Next match", upcoming: "Upcoming matches",
    recentResults: "Latest results", standings: "Standings",
    trainings: "This week's trainings", clubNews: "Club news",
    social: "Social media", teams: "Teams", contact: "Contact",
    today: "Today", tomorrow: "Tomorrow", position: "Position",
    viewAll: "View all", joinClub: "Join FC Inkad",
    tPos: "#", tTeam: "Team", tPl: "P", tW: "W", tD: "D", tL: "L", tPts: "Pts",
    jHeroKicker: "Inkad Youth · Diegem",
    jHero1: "Growing", jHero2: "together", jHero3: "and playing",
    jHeroLead: "A warm place for children and teens. Activities, homework class, camps and solidarity.",
    nextActivity: "Next activity", sundayActivities: "Sunday activities", homeworkClass: "Homework class",
    holidayCamps: "Holiday camps", recentActivities: "Recent activities",
    charity: "Charity", newsStories: "News & stories",
    joinJeugd: "Register your child", whatWeDo: "What do we do?",
    whenNext: "When is the next activity?", howJoin: "How can my child join?",
    regFcTitle: "Register at FC Inkad", regFcLead: "Fill in the form and our board will contact you.",
    regJeugdTitle: "Register at Inkad Youth", regJeugdLead: "Register your child for our activities. We'll send all the info.",
    fName: "Name", fParent: "Parent/guardian name", fEmail: "Email",
    fPhone: "Phone", fBirth: "Birth year", fProgram: "Branch / team",
    fMessage: "Message", submit: "Submit registration", sending: "Sending...",
    fFirstName: "First name", fLastName: "Last name", fBirthDate: "Date of birth",
    fGender: "Gender", fBoy: "Boy", fGirl: "Girl", fAddress: "Address",
    fRegisterFor: "What would you like to register for?",
    progHuiswerk: "Homework guidance", progZondag: "Sunday activity (weekly)",
    volzetTag: "full",
    feeNotice: "Membership fee: €{amt} — payable online via Mollie right after submitting.",
    submitPay: "Register & pay €{amt}",
    multipleAllowed: "multiple choices allowed",
    feeOnRequest: "on request",
    huiswerkNote: "Homework guidance: the amount is agreed after a first conversation.",
    payConfirming: "Confirming payment…", payPaid: "Payment successful! Your registration is confirmed.",
    payOpen: "Payment not completed yet. We keep checking the status.",
    payFailed: "Payment failed or was cancelled.", payRetry: "Try again",
    backToClub: "Back to FC Inkad", backToYouth: "Back to Inkad Youth",
    regOk: "Thank you! Your registration was received.", regErr: "Something went wrong. Try again.",
    cName: "Name", cEmail: "Email", cMessage: "Message", cSend: "Send",
    contactLead: "Questions? Feel free to get in touch.", contactOk: "Message sent. Thank you!",
    footerRights: "All rights reserved.",
  },
  fr: {
    hubKicker: "Club de jeunesse & sport · Diegem",
    hubTitle1: "Quel Inkad", hubTitle2: "cherchez-vous ?",
    hubLead: "Une jeunesse amusante et enrichissante pour tous.",
    fcTag: "Club de sport", fcDesc: "Futsal, football, matchs et classements. Il se passe quelque chose chaque jour.",
    jeugdTag: "Club de jeunesse", jeugdDesc: "Activités, aide aux devoirs, camps et charité pour nos jeunes.",
    enter: "Découvrir", otherBranch: "Autre branche d'Inkad", backToInkad: "Inkad", discoverInkad: "Découvrir Inkad",
    nav_futsal: "Futsal", nav_minis: "Minis", nav_veteranen: "Vétérans",
    nav_wedstrijden: "Matchs", nav_inschrijven: "Inscription",
    nav_veldvoetbal: "Football",
    chooseSport: "Choisissez votre sport",
    lastResult: "Dernier résultat", allMatches: "Tous les matchs", allTeams: "Toutes les équipes",
    lastUpdated: "Dernière mise à jour", competition: "Compétition",
    officialData: "Données officielles · Voetbal Vlaanderen",
    tGF: "BP", tGA: "BC", tGD: "DB",
    stPlanned: "Prévu", stLive: "LIVE", stFinished: "Terminé", stPostponed: "Reporté",
    stCancelled: "Annulé", stForfeit: "Forfait",
    nav_clubshop: "Boutique",
    nav_ploegen: "Équipes",
    ploegenTitle: "Nos équipes",
    ploegenKicker: "FC Inkad · Toutes les équipes",
    ploegenLead: "Découvrez nos équipes et coachs — des plus petits aux vétérans.",
    coachLabel: "Coach", coachSoon: "Coach bientôt disponible",
    teamPhotoSoon: "Photo d'équipe bientôt disponible",
    catJeugd: "Jeunes", catSenioren: "Seniors", catFutsal: "Futsal", catVeteranen: "Vétérans",
    stafKicker: "Notre équipe", stafTitle: "Staff & Coordination", roleJeugdcoordinator: "Coordinateur des jeunes", roleVoorzitter: "Président",
    shopSoonBadge: "Bientôt disponible",
    shopSoonText: "Notre boutique officielle ouvre bientôt. Commandez-y les vêtements et accessoires du club via notre fournisseur — exclusivement pour les membres et supporters du FC Inkad.",
    shopFollow: "Suivez le lancement sur nos réseaux",
    sponsors: "Nos sponsors",
    resultsTab: "Résultats", all: "Tous", noMatches: "Aucun match trouvé.",
    followTiktok: "Suivez @inkad.diegem sur TikTok",
    nav_activiteiten: "Activités du dimanche", nav_huiswerkklas: "Aide aux devoirs",
    fotosLabel: "Photos",
    nav_vakantiekampen: "Camps", nav_liefdadigheid: "Charité",
    nav_galerij: "Galerie",
    galerijTitle: "Notre Galerie", galerijLead: "Un aperçu de tout ce que nous vivons ensemble — des activités aux camps et aux fêtes.",
    galerijEmpty: "Nos photos apparaîtront bientôt ici.",
    fcHeroKicker: "FC Inkad · Diegem",
    fcHero1: "Chaque jour", fcHero2: "en mouvement", fcHero3: "sur le terrain",
    fcHeroLead: "Futsal, minis et vétérans. Matchs, classements et actualités — mis à jour en direct.",
    liveUpdated: "Mis à jour en direct", nextMatch: "Prochain match", upcoming: "Matchs à venir",
    recentResults: "Derniers résultats", standings: "Classement",
    trainings: "Entraînements de la semaine", clubNews: "Actualités du club",
    social: "Réseaux sociaux", teams: "Équipes", contact: "Contact",
    today: "Aujourd'hui", tomorrow: "Demain", position: "Position",
    viewAll: "Voir tout", joinClub: "Rejoindre FC Inkad",
    tPos: "#", tTeam: "Équipe", tPl: "J", tW: "V", tD: "N", tL: "D", tPts: "Pts",
    jHeroKicker: "Inkad Jeunesse · Diegem",
    jHero1: "Grandir", jHero2: "ensemble", jHero3: "et jouer",
    jHeroLead: "Un lieu chaleureux pour enfants et ados. Activités, aide aux devoirs, camps et solidarité.",
    nextActivity: "Prochaine activité", sundayActivities: "Activités du dimanche", homeworkClass: "Aide aux devoirs",
    holidayCamps: "Camps de vacances", recentActivities: "Activités récentes",
    charity: "Charité", newsStories: "Actualités & récits",
    joinJeugd: "Inscrire mon enfant", whatWeDo: "Que faisons-nous ?",
    whenNext: "Quand a lieu la prochaine activité ?", howJoin: "Comment mon enfant peut-il participer ?",
    regFcTitle: "Inscription à FC Inkad", regFcLead: "Remplissez le formulaire, notre comité vous contactera.",
    regJeugdTitle: "Inscription à Inkad Jeunesse", regJeugdLead: "Inscrivez votre enfant. Nous vous enverrons toutes les infos.",
    fName: "Nom", fParent: "Nom du parent/tuteur", fEmail: "E-mail",
    fPhone: "Téléphone", fBirth: "Année de naissance", fProgram: "Branche / équipe",
    fMessage: "Message", submit: "Envoyer l'inscription", sending: "Envoi...",
    fFirstName: "Prénom", fLastName: "Nom", fBirthDate: "Date de naissance",
    fGender: "Sexe", fBoy: "Garçon", fGirl: "Fille", fAddress: "Adresse",
    fRegisterFor: "Pour quoi souhaitez-vous vous inscrire ?",
    progHuiswerk: "Aide aux devoirs", progZondag: "Activité du dimanche (hebdo)",
    volzetTag: "complet",
    feeNotice: "Cotisation : €{amt} — à payer en ligne via Mollie juste après l'envoi.",
    submitPay: "S'inscrire & payer €{amt}",
    multipleAllowed: "plusieurs choix possibles",
    feeOnRequest: "à convenir",
    huiswerkNote: "Aide aux devoirs : le montant est convenu après un premier entretien.",
    payConfirming: "Confirmation du paiement…", payPaid: "Paiement réussi ! Votre inscription est confirmée.",
    payOpen: "Paiement pas encore finalisé. Nous vérifions le statut.",
    payFailed: "Le paiement a échoué ou a été annulé.", payRetry: "Réessayer",
    backToClub: "Retour à FC Inkad", backToYouth: "Retour à Inkad Jeunesse",
    regOk: "Merci ! Votre inscription a été reçue.", regErr: "Une erreur est survenue. Réessayez.",
    cName: "Nom", cEmail: "E-mail", cMessage: "Message", cSend: "Envoyer",
    contactLead: "Des questions ? N'hésitez pas à nous contacter.", contactOk: "Message envoyé. Merci !",
    footerRights: "Tous droits réservés.",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("inkad_lang") || "nl");
  const change = useCallback((l) => { setLang(l); localStorage.setItem("inkad_lang", l); }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || dict.nl[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
export const LANGS = ["nl", "en", "fr"];
